import React, { useState } from "react";
import {
    Grid,
    IconButton,
    Backdrop,
    CircularProgress,
} from "@material-ui/core";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack, Error } from "@mui/icons-material";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import GetInvoiceTable from "./reportTables/GetInvoiceTable.js";
import LongOutStandingTable from "./reportTables/LongOutStandingTable.js";
import QueriesResponseTable from "./reportTables/QueriesResponseTable.js";

const useStyles = makeStyles(dashboardStyle);

const headers = [
    { label: "Invoice No", key: "invoiceNo" },
    { label: "Vendor Code", key: "vendorCode" },
    { label: "Vendor Name", key: "vendorName" },
    { label: "Query Stage", key: "queryStage" },
    { label: "Query Date", key: "queryDate" },
    { label: "Invoice Type", key: "invoiceType" },
    { label: "Raised By", key: "raisedBy" },
    { label: "Resolution Date", key: "resolutionDate" },
    { label: "Return By", key: "returnBy" },
    { label: "Response Days*", key: "responseDays" },

];

export default function QueriesResponseTime() {
    const classes = useStyles();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sendloader, setSendloader] = useState(false);

    const [countNo, setCountNo] = React.useState(1); // Set default page to 0

    return (
        <div>
            {" "}
            <>
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={sendloader}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Card style={{ marginLeft: "20px" }}>
                    <CardHeader color="primary" text>
                        <CardText
                            style={{
                                padding: "1px 27px",
                                backgroundColor: "#031C30",
                                color: "white",
                                height: "62px",
                            }}
                        >
                            <Grid container justifyContent="space-between">
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <h4> Get Queries Response Time </h4>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <IconButton
                                        variant="contained"
                                        style={{ float: "right", marginTop: "1.5%" }}
                                        onClick={() => navigate("/home")}
                                    >
                                        <ArrowBack
                                            style={{ color: "#fff" }}
                                            titleAccess="Go Back"
                                        />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </CardText>
                    </CardHeader>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <QueriesResponseTable
                            loading={loading}
                            setCountNo={setCountNo}
                            header={headers}
                            data={data}
                            dropdownValue={"InvoiceStatus"}
                            setData={setData}
                            setLoading={setLoading}
                        />
                    </Grid>
                </Card>
            </>
        </div>
    );
}
